import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import {reaction, toJS} from "mobx";
import ListSelector from "./ListSelector";
import axios from "../../utils/axios";

class RemoteList extends Component {
  constructor(props) {
    super(props);
    this.state={
      inited:false,
      fields:[],
      detail:{},
    };
  }
  getSelectIdCode() {
    return this.props.field.select_id_code || "value";
  }
  componentDidMount() {
    reaction(()=>{
      return this.props.item[this.getValueField()];
    },(val)=>{
      if(val) {
        this.getById(val);
      } else {
        this.setState({detail:  {} });
      }
    },{ fireImmediately:true })
    /*axios.post(this.props.field.list_route,{ items_per_page:999999, page:1 }).then((data)=>{
      this.setState({ fields: data.data.answer.items, inited: true });
    });*/
  }

  inputRef(ref) {
    if(this.props.inputRef) {
      this.props.inputRef(ref);
    }
  }
  getList(str,callback) {
    if(this._getListTa) {
      clearTimeout(this._getListTa);
    }
    this._getListTa=setTimeout(()=>{
      const name='%'+str.replace(/\ /gi, "%")+'%';
      const sign=this.props.field.list_route.indexOf('?')>-1?'&':'?';
      const searchField=this.props.field.search_field?this.props.field.search_field:'~name'
      const select=['id','name'];
      if(typeof this.props.field.visible_fields !== 'undefined') {
        const visible_fields=JSON.parse(JSON.stringify(this.props.field.visible_fields));
        if(this.props.field.title_field) {
          visible_fields.push(this.props.field.title_field)
        }
        visible_fields.splice(0,0,2,0);
        select.splice.apply(select, visible_fields);
      }
      axios.post(`${this.props.field.list_route}`,{ select:select, filter:{ [searchField]:name }, items_per_page:10000 }).then((data)=>{
        callback(data.data.answer.items || []);
      });
    },300)
  }
  getById(val) {
    if(val) {
      const select=['id','name'];
      if(typeof this.props.field.visible_fields !== 'undefined') {
        const visible_fields=JSON.parse(JSON.stringify(this.props.field.visible_fields));
        if(this.props.field.title_field) {
          visible_fields.push(this.props.field.title_field)
        }
        visible_fields.splice(0,0,2,0);
        select.splice.apply(select, visible_fields);
      }
      axios.post(`${this.props.field.list_route}`, {select: select, filter: {id: val}}).then((data) => {
        this.setState({detail: (data.data.answer.items && data.data.answer.items.length) ? data.data.answer.items[0] : {}});
      });
    }
  }
  getIdField() {
    return this.props.field.id_field || "id";
  }
  getValueField() {
    return this.props.field.value_field || "value";
  }
  render() {
    const addProps={};

    if(this.props.locked) {
      const ret=this.props.field.title_field?this.state.detail[this.props.field.title_field]:this.state.detail.name;
      return ret || null;
    }

    if(this.props.field.visible_fields) {
      addProps.visible_fields = this.props.field.visible_fields;
    }

    return (
      <ListSelector
        relative={true}
        onBeforeChange={(e)=>{
          const arg=e.target.value.matchAll(/([<>=!~]?[><=]?)(.+)/gi).next();
          if(arg.value) {
            if(arg.value[2]) {
              if(arg.value[1] === '~' ||arg.value[1] === '=' || arg.value[1] === '!=' || arg.value[1] === '>' || arg.value[1] === '<' || arg.value[1] === '>=' || arg.value[1] === '<=') {
                this.props.item.compare=arg.value[1];
                e.target.value=arg.value[2];
              }
            }
          }
        }}
        helperOnBlank={"Начните вводить название для поиска"}
        onLock={()=>{
          if(this.props.onLock) {
            this.props.onLock();
          }
        }}
        inputRef={(ref)=>{ this.inputRef(ref); }}
        idValue={this.props.item[this.getValueField()]}
        onSelectId={(id)=>{
          this.props.item[this.getValueField()] = id;
          this.props.item.focus = 1;
        }}
        titleValue={this.props.field.title_field?this.state.detail[this.props.field.title_field]:this.state.detail.name}
        filterFunction={(str,callback)=>{
          this.getList(str,callback);
        }}
        idField={this.getIdField()}
        valueField={this.getValueField()}
        titleField={this.props.field.title_field?this.props.field.title_field:"name"}
        onNewFied={()=>{
          this.props.onNewFied();
        }}
        onCancel={()=>{
          this.props.onCancel();
        }}
        onSelect={(item)=>{
          if(item) {
            this.props.item[this.getValueField()] = item.id;
            this.props.item.focus = 1;
          } else {
            if(!this.props.deleteOnly) {
              this.props.item[this.getValueField()] = '';
              this.props.item.focus = 1;
            }
          }
        }}
        onFocus={()=>{
          if(this.props.onFocus) {
            this.props.onFocus();
          }
        }}
        onBlur={()=>{
          if(this.props.onBlur) {
            this.props.onBlur();
          }
        }}
        selected_value={this.props.item[this.getValueField()]}
        placeholder={this.props.placeholder}
        {...addProps}
      />
    )
  }
}

// export default inject("configStore")(observer(RemoteList));
export default observer(RemoteList);